<template>
    <div v-if="show">
        <div class="card" v-show="operation !== 'detail'">
            <div class="card-header card-header-flex pb-2">
                <div class="w-100 mt-2">
                    <div class="row">
                        <div class="col-8">
                            <h5 class="mt-3 ml-0 mr-3 mb-2">
                                <strong>
                                    <template v-if="operation === null">
                                        {{$t('title.dealerToDealerLoads')}}
                                        <span v-if="pagination.total">({{pagination.total}})</span>
                                    </template>
                                    <template v-else>{{ $t(operationTitle) }}</template>
                                </strong>
                            </h5>
                        </div>
                        <div class="col-4 text-right">
                            <div v-if="operation === null">
                                <div class="mt-3">
                                    <!-- Using components -->
                                    <b-input-group class="mt-3">
                                        <b-form-input type="search" class="form-control form-control-sm"
                                                      :placeholder="$t('input.whatAreYouLookingFor')"
                                                      v-on:keyup.enter="handleSearch" v-model="search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" :title="$t('button.title.filterRecords')"
                                                      variant="outline-info"
                                                      @click="filters.visible = !filters.visible" v-b-tooltip.hover
                                                      v-if="$global.hasPermission('ddloadsview')">
                                                <i class="fa fa-filter"></i>
                                            </b-button>
                                            <b-button size="sm" :title="$t('button.title.exportExcel')"
                                                      variant="outline-info"
                                                      @click="handleExcelExportClick" v-b-tooltip.hover
                                                      v-if="$global.hasPermission('ddloadsview')">
                                                <i class="fa fa-file-excel-o"></i>
                                            </b-button>
                                            <b-button size="sm" :title="$t('button.title.resetList')"
                                                      variant="outline-info"
                                                      @click="handleResetFilterClick()" v-b-tooltip.hover>
                                                <i class="fa fa-refresh"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </div>
                            <div v-else>
                                <b-button variant="warning" size="sm" class="mt-3"
                                          @click="handleOperationClose()"
                                          v-b-tooltip.hover :title="$t('button.title.cancel')">
                                    <i class="fa fa-arrow-left"></i> {{$t('button.cancel')}}
                                </b-button>
                            </div>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.w-100 -->
            </div><!-- /.card-header -->
            <div class="card-body">
                <div class="dd-table" v-show="!operation">
                    <b-table hover responsive
                             ref="table"
                             :busy="listingLoading"
                             :items="dataSource"
                             :fields="columns"
                             :sort-by.sync="sortField"
                             @sort-changed="handleSortChange">
                        <template v-slot:cell(id)="{ item, index}">
                            {{ (pagination.perPage * (pagination.current-1)) + (index + 1) }}
                        </template>
                        <template v-slot:cell(supplier_carrier_id)="record">
                            {{record.item.supplier_carrier ? record.item.supplier_carrier.name : ''}}
                        </template>
                        <template v-slot:cell(client_id)="record">
                            {{record.item.client ? record.item.client.company_name : ''}}
                        </template>
                        s
                        <template v-slot:cell(vin_number)="record">
                            {{record.item.dealer_to_dealer_load_orders.map(item => (item.order ||
                            {}).vin_number).join(', ')}}
                        </template>
                        <template v-slot:cell(to_dealer_id)="record">
                            {{record.item.to_dealer ? record.item.to_dealer.name : ''}}
                        </template>
                        <template v-slot:cell(from_to_dealer_id)="{item}">
                            <span v-for="i in item.dealer_to_dealer_load_orders">
                                {{(i.from_dealer || {}).name}}
                            </span>
                        </template>
                        <template v-slot:cell(from_location_id)="{item}">
                            <span
                                v-if="item.dealer_to_dealer_load_orders[0] && item.dealer_to_dealer_load_orders[0].from_location">
                                <print-ad
                                    :item="item.dealer_to_dealer_load_orders[0] && item.dealer_to_dealer_load_orders[0].from_location"
                                    titled="1"></print-ad>
                            </span>
                        </template>
                        <template v-slot:cell(to_location_id)="{item}">
                            <span
                                v-if="item.dealer_to_dealer_load_orders[0] && item.dealer_to_dealer_load_orders[0].to_location">
                                <print-ad
                                    :item="item.dealer_to_dealer_load_orders[0] && item.dealer_to_dealer_load_orders[0].to_location"
                                    titled="1"></print-ad>
                            </span>
                        </template>
                        <template v-slot:cell(transport_vehicle_id)="record">
                            <span v-if="record.item.transport_vehicle">
                                <span v-if="record.item.transport_vehicle.truck_plate_number"> {{ record.item.transport_vehicle.truck_plate_number }} </span>
                                <span v-if="record.item.transport_vehicle.trailer_plate_number"> | {{ record.item.transport_vehicle.trailer_plate_number }} </span>
                            </span>
                        </template>
                        <template v-slot:cell(driver_id)="record">
                            {{record.item.driver ? record.item.driver.name : ''}}
                        </template>
                        <template v-slot:cell(loading_date)="record">
                            <span v-if="record.item.estimated_loading_time">
                                {{$global.utcDateToLocalDate(record.item.estimated_loading_time) }}
                            </span>
                        </template>
                        <template v-slot:cell(status)="record">
                            <re-status :status="record.item.status"></re-status>
                        </template>
                        <template v-slot:cell(action)="record">
                            <a @click="setOperation('edit', record.item.id)"
                               :title="$t('button.title.editItem')"
                               v-if="$global.hasPermission('ddloadsupdate') && $global.hasAnyRole(['superadmin', 'efl'])
                                && record.item.status < 4" class="ml-1"
                               v-b-tooltip.hover>
                                <i class="fe fe-edit"></i>
                            </a>

                            <a-popconfirm title="Are you sure？" @confirm="handleDeleteClick(record.item.id)"
                                          v-if="$global.hasPermission('ddloadsdestroy') && record.item.status <= 3">
                                <i slot="icon" class="fe fe-trash"></i>
                                <a class="ml-1" :title="$t('button.title.deleteItem')" v-b-tooltip.hover>
                                    <i class="fe fe-trash"></i>
                                </a>
                            </a-popconfirm>

                            <a @click="setOperation('detail', record.item.id)"
                               :title="$t('button.title.detailItem')" class=" ml-1"
                               v-if="$global.hasPermission('ddloadsdetail') && $global.hasAnyRole(['superadmin', 'efl', 'efluser'])"
                               v-b-tooltip.hover>
                                <i class="icmn-info"></i>
                            </a>
                        </template>
                        <template v-slot:row-details="{ item }">
                            <b-list-group-item><strong>{{$t('column.skipDealerConfirmation')}}</strong>:
                                {{item.skip_dealer_confirmation ? $t('msc.yes') : $t('msc.no')}}
                            </b-list-group-item>
                        </template>
                    </b-table><!-- /.b-table -->

                    <div class="clearfix">
                        <div class="float-left">
                            <b-form-select v-model="pagination.perPage" :options="[5, 10, 50, 100, 1000]"
                                           size="sm"></b-form-select>
                        </div>
                        <div class="float-right">
                            <b-pagination
                                v-model="pagination.current"
                                :total-rows="pagination.total"
                                :per-page="pagination.perPage"
                                :first-text="$t('paginations.first')"
                                :prev-text="$t('paginations.prev')"
                                :next-text="$t('paginations.next')"
                                :last-text="$t('paginations.last')"
                            ></b-pagination>
                        </div><!-- /.pull-right -->
                    </div><!-- /.clearfix -->
                </div><!-- /.dd-table-->

                <div class="dd-operation">
                    <div v-if="operation === 'edit'">
                        <form @submit.prevent="handleSubmit" autocomplete="off">
                            <b-row>
                                <b-col cols="12" v-show="global.pendingRequests > 0">
                                    <a-skeleton active :paragraph="{ rows: 5 }"/>
                                </b-col>

                                <b-col cols="12" v-show="global.pendingRequests <= 0">
                                    <b-row>
                                        <b-col md="6" lg="6" sm="12">
                                            <b-row>
                                                <b-col md="6" lg="6" sm="12">
                                                    <b-form-group
                                                        :label="$t('input.supplierCarrier')+' *'"
                                                        label-for="supplier_id"
                                                        :invalid-feedback="formErrors.first('supplier_carrier_id') || formErrors.first('price_id') || formErrors.first('route_id') || formErrors.first('price_period_id')"
                                                    >
                                                        <treeselect
                                                            :multiple="false"
                                                            :disabled="formFields.status >= 4"
                                                            :options="dropdowns.supplierCarriers"
                                                            placeholder=""
                                                            v-model="formFields.supplier_carrier_id"
                                                            :class="[{'invalid is-invalid': (formErrors.has('supplier_carrier_id') || formErrors.has('price_id') || formErrors.has('route_id') || formErrors.has('price_period_id'))}]"
                                                        />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col md="6" lg="6" sm="12">
                                                    <b-form-group
                                                        :label="$t('input.dealer')+' *'"
                                                        label-for="to_dealer_id"
                                                        :invalid-feedback="formErrors.first('to_dealer_id')"
                                                    >
                                                        <treeselect
                                                            :multiple="false"
                                                            :disabled="formFields.status >= 4"
                                                            :options="dropdowns.dealers"
                                                            placeholder=""
                                                            v-model="formFields.to_dealer_id"
                                                            :class="[{'invalid is-invalid': (formErrors.has('to_dealer_id'))}]"
                                                        />
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>

                                        <b-col md="6" lg="6" sm="12">
                                            <b-form-group
                                                :label="$t('input.toLocation')+' *'"
                                                label-for="location_id"
                                                :invalid-feedback="formErrors.first('location_id')"
                                            >
                                                <treeselect
                                                    :multiple="false"
                                                    :options="dropdowns.locations"
                                                    placeholder=""
                                                    :disabled="true"
                                                    v-model="formFields.to_location_id"
                                                    :class="[{'invalid is-invalid': (formErrors.has('location_id'))}]"
                                                />
                                            </b-form-group>
                                        </b-col>

                                        <b-col md="6" lg="6" sm="12">
                                            <div class="form-group">
                                                <div class="clearfix">
                                                    <span class="pull-left">
                                                        <label class="d-block">{{$t('input.order')}}</label>
                                                    </span><!-- /.pull-left -->
                                                    <span class="pull-left ml-2 mb-1">
                                                        <button class="btn btn-warning btn-sm" v-b-tooltip.hover
                                                                :title="$t('button.title.addNewOrder')" type="button"
                                                                @click="handleAddOrderClick">{{$t('button.add')}}</button>
                                                    </span><!-- /.pull-left -->
                                                </div><!-- /.clearfix -->
                                                <treeselect
                                                    :multiple="false"
                                                    :options="dropdowns.orders"
                                                    placeholder=""
                                                    v-model="selectedOrderId"
                                                    :class="[{'invalid is-invalid': (formErrors.has('order_id'))}]"/>
                                                <div class="invalid-feedback">{{formErrors.first('order_id')}}</div>
                                            </div>
                                        </b-col>

                                        <b-col md="6" lg="6" sm="12">
                                            <b-row>
                                                <b-col sm="4" v-if="formFields.status == 3">
                                                    <b-form-group
                                                        :label="$t('input.status') + ':'"
                                                        :invalid-feedback="formErrors.first('announce')"
                                                    >
                                                        <b-form-checkbox v-model="formFields.announce" name="announce">
                                                            {{$t('title.announce')}}
                                                        </b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>

                                        <b-col md="6" lg="6" sm="12">
                                            <b-form-group
                                                :label="$t('input.comment')"
                                                label-for="comment"
                                                :invalid-feedback="formErrors.first('comments')">
                                                <b-textarea
                                                    id="comment"
                                                    v-model="formFields.comments"
                                                    type="text"
                                                    :state="((formErrors.has('comments') ? false : null))"
                                                    @focus="$event.target.select()"
                                                ></b-textarea>
                                            </b-form-group>
                                        </b-col>

                                        <b-col md="6" lg="6" sm="12" v-if="formFields.status < 5">
                                            <div class="form-group mb-1 mt-2">
                                                <b-form-checkbox v-model="formFields.skip_dealer_confirmation"
                                                                 name="check-button">
                                                    {{$t('input.skipDealerConfirmation')}}
                                                </b-form-checkbox>
                                            </div>
                                        </b-col>

                                        <b-col sm="12">
                                            <h3 class="text-secondary">{{$t('title.existingOrders')}}</h3>
                                            <hr/>

                                            <small class="text-danger" v-if="formErrors.has('orders')">{{formErrors.first('orders')}}</small>
                                            <table class="table table-hover"
                                                   v-if="editLoad && editLoad.dealer_to_dealer_load_orders">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>{{$t('column.orderId')}}</th>
                                                    <th>{{$t('column.dealer')}}</th>
                                                    <th>{{$t('column.brand')}}</th>
                                                    <th>{{$t('column.model')}}</th>
                                                    <th class="text-right">{{$t('column.action')}}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(ilo, index) in editLoad.dealer_to_dealer_load_orders"
                                                    :class="{'bg-light-danger': _.includes(formFields.deleted_orders, ilo.order.id)}">
                                                    <td>{{index + 1}}</td>
                                                    <td>{{ilo.order.order_id}}</td>
                                                    <td>{{(ilo.from_dealer || {}).name}}</td>
                                                    <td>{{(ilo.order.brand || {}).title}}</td>
                                                    <td>{{(ilo.order.model || {}).title}}</td>
                                                    <td class="text-right">
                                                        <a-popconfirm title="Are you sure？"
                                                                      @confirm="handleDeleteOrderClick(ilo.order.id)"
                                                                      v-if="!_.includes(formFields.deleted_orders, ilo.order.id)">
                                                            <i slot="icon" class="fe fe-trash"></i>
                                                            <a class=" ml-1"
                                                               :title="$t('button.title.deleteItem')"
                                                               v-b-tooltip.hover>
                                                                <i class="fe fe-trash"></i>
                                                            </a>
                                                        </a-popconfirm>
                                                        <template v-if="formFields.new_orders.length <= 0">
                                                            <a class="ml-1"
                                                               v-if="_.includes(formFields.deleted_orders, ilo.order.id) && formFields.new_orders.length <= 0"
                                                               @click="handleUndoDeleteClick(ilo.order.id)"
                                                               :title="$t('button.title.undo')"
                                                               v-b-tooltip.hover>
                                                                <i class="fa fa-undo"></i>
                                                            </a>
                                                        </template>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <h3 class="text-secondary">{{$t('title.newOrders')}}</h3>
                                            <hr/>
                                            <table class="table table-hover"
                                                   v-if="editLoad && formFields.new_orders.length">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>{{$t('column.orderId')}}</th>
                                                    <th>{{$t('column.dealerLocation')}}</th>
                                                    <th>{{$t('column.dealer')}}</th>
                                                    <th>{{$t('column.action')}}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(ilo, index) in formFields.new_orders">
                                                    <td>{{index + 1}}</td>
                                                    <td>{{ilo.order_id}}</td>
                                                    <td>
                                                        <print-ad :item="ilo.dealer_location"></print-ad>
                                                    </td>
                                                    <td>{{(ilo.dealer || {}).name}}</td>
                                                    <td>
                                                        <a-popconfirm title="Are you sure？"
                                                                      @confirm="handleDeleteNewOrderClick(ilo.id)">
                                                            <i slot="icon" class="fe fe-trash"></i>
                                                            <a class=" ml-1"
                                                               :title="$t('button.title.deleteItem')"
                                                               v-b-tooltip.hover>
                                                                <i class="fe fe-trash"></i>
                                                            </a>
                                                        </a-popconfirm>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <hr/>

                                            <b-row class="operation-footer">
                                                <b-col sm="12">
                                                    <b-button
                                                        size="sm"
                                                        type="submit"
                                                        variant="primary"
                                                        :disabled="global.pendingRequests > 0"
                                                        v-b-tooltip.hover :title="$t('button.title.save')"
                                                    >
                                                        <clip-loader style="display: inline" :loading="true"
                                                                     color="#fff"
                                                                     size="12px"
                                                                     v-if="global.pendingRequests > 0"></clip-loader>
                                                        <i class="fa fa-save mr-1"></i>
                                                        {{$t('button.save')}}
                                                    </b-button>
                                                    <b-button variant="warning" class="ml-3"
                                                              size="sm" @click="handleOperationClose()"
                                                              v-b-tooltip.hover :title="$t('button.title.cancel')">
                                                        <i class="fa fa-arrow-left mr-1"></i> {{$t('button.cancel')}}
                                                    </b-button>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </form>
                    </div>
                </div><!--/.dd-operation-->

                <div class="filter-container">
                    <a-drawer
                        placement="left"
                        :width="'360px'"
                        :wrapStyle="{overflow: 'auto',paddingBottom: '108px'}"
                        :closable="false"
                        @close="filters.visible = !filters.visible"
                        :visible="!operation && filters.visible"
                        :zIndex="10"
                        :title="$t('title.advanceFilters')"
                    >
                        <form @submit.prevent="loadList(listQueryParams, true)" autocomplete="off">
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.client')">
                                        <treeselect
                                            :multiple="true"
                                            :options="_.filter(dropdowns.clients,(i) => i.id = i.label)"
                                            placeholder=""
                                            v-model="filters.clients"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.dealers')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.dealers"
                                            placeholder=""
                                            v-model="filters.dealers"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.carriers')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.supplierCarriers"
                                            placeholder=""
                                            v-model="filters.supplierCarriers"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.brands')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.brands"
                                            placeholder=""
                                            v-model="filters.brands"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.models')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.models"
                                            placeholder=""
                                            v-model="filters.models"
                                            @input="handleSelectModelsSelect"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.code')">
                                        <treeselect
                                            :multiple="true"
                                            :options=" _.uniqBy(_.filter(dropdowns.configCode, ({ model_id }) => _.every([_.includes(filters.models, model_id)])),'id')"
                                            placeholder=""
                                            v-model="filters.configCode"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.loadingPoint')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.loadingPoint"
                                            placeholder=""
                                            v-model="filters.loadingPoint"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.unloadingPoint')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.unloadingPoint"
                                            placeholder=""
                                            v-model="filters.unloadingPoint"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.drivers')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.drivers"
                                            placeholder=""
                                            v-model="filters.drivers"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.vehicles')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.vehicles"
                                            placeholder=""
                                            v-model="filters.vehicles"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.status')">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.status"
                                            placeholder=""
                                            v-model="filters.status"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group :label="$t('input.fromAddedDate')">
                                        <b-form-datepicker placeholder="" v-model="filters.from_date"
                                                           class="mb-2"></b-form-datepicker>
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group :label="$t('input.toAddedDate')">
                                        <b-form-datepicker placeholder="" v-model="filters.to_date"
                                                           class="mb-2"></b-form-datepicker>
                                    </b-form-group>
                                </b-col><!--/b-col-->
                            </b-row>
                            <div class="drawer-footer">
                                <b-button size='sm' variant="info" @click="filters.visible = !filters.visible"
                                          class="mr-2" :title="$t('button.title.closePanel')" v-b-tooltip.hover>
                                    {{$t('button.close')}}
                                </b-button>
                                <b-button size='sm' variant="warning" @click="handleResetFilterClick" class="mr-2"
                                          :title="$t('button.title.resetFilter')" v-b-tooltip.hover>
                                    {{$t('button.reset')}}
                                </b-button>
                                <b-button size='sm' variant="primary" button="submit" type="filled"
                                          :title="$t('button.title.filterRecords')" v-b-tooltip.hover>
                                    {{$t('button.apply')}}
                                </b-button>
                            </div><!-- /.drawer-footer -->
                        </form>
                    </a-drawer>
                </div><!-- /.filter-container -->

            </div><!-- /.card-body-->
        </div><!-- /.card -->
        <div v-if="operation === 'detail'">
            <detail :handle-close-operation="handleOperationClose"></detail>
        </div>

        <!-- # Excel Export -->
        <b-modal id="excel-export-modal" v-model="exportModal.visibility" hide-footer>
            <template #modal-title>
                {{$t('title.exportExcel')}}
            </template>
            <div>
                <form @submit.prevent="handleExcelExportSubmitClick">
                    <div class="mb-5">
                        <b-form-group>
                            <a href="javascript:;" class="p-3" @click="handleExcelExportSelectAllClick">{{$t('input.checkAll')}}</a>
                            <a href="javascript:;" class="p-3" @click="handleExcelExportUnSelectAllClick">{{$t('input.unCheckAll')}}</a>
                        </b-form-group>
                        <hr>
                        <table class="table table-sm">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>{{$t('title.columns')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(column, index) in exportModal.columns">
                                <td>{{index + 1}}</td>
                                <td>
                                    <b-form-checkbox v-model="column.show"
                                                     name="check-button">{{column.label}}
                                    </b-form-checkbox>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="drawer-footer">
                        <json-excel
                            class="btn btn-primary btn-sm"
                            :fields="exportModal.headers"
                            worksheet="Orders"
                            :fetch="handleExcelExportSubmitClick"
                            name="dealer_to_dealer_loads.xls">
                            <clip-loader style="display: inline" :loading="true" color="#fff"
                                         size="12px" v-if="global.pendingRequests > 0"></clip-loader>
                            <i class="fa fa-save mr-1"></i>
                            {{$t('button.export')}}
                        </json-excel>
                        <b-button variant="warning" class="ml-3"
                                  size="sm" @click="handleExcelExportCancelClick()"
                                  v-b-tooltip.hover :title="$t('button.title.cancel')">
                            <i class="fa fa-arrow-left mr-1"></i> {{$t('button.cancel')}}
                        </b-button>
                    </div>
                </form>
            </div>
        </b-modal><!--/#excel-export-modal-->
    </div>
</template>
<script>
    import ListingMixin from '../../util/ListingMixin'
    import Error from '../../util/Error'
    import {mapState} from 'vuex'
    import Datepicker from 'vuejs-datepicker'
    import {request} from '../../util/Request'
    import Treeselect from '@riophae/vue-treeselect'
    import Detail from './detail'
    import qs from "qs"
    import {getAuthUser} from "../../util/Utils"
    import ExcelExportMixin from "./ExcelExportMixin";
    import JsonExcel from "vue-json-excel"


    const FORM_STATE = {
        supplier_carrier_id: null,
        to_dealer_id: null,
        route_id: null,
        price_id: null,
        price_period_id: null,
        to_location_id: null,
        id: null,
        comments: null,
        price: 0,
        currency: null,
        skip_dealer_confirmation: false,
        dealer_to_dealer_load_orders: [],
        status: 2,
        announce: false,
        _method: 'post',
        deleted_orders: [],
        new_orders: [],
    };

    const FILTER_STATE = {
        visible: false,
        from_date: null,
        to_date: null,
        brands: [],
        models: [],
        configCode: [],
        drivers: [],
        vehicles: [],
        status: [1, 2, 3, 4, 5, 6, 7],
        loadingPoint: [],
        unloadingPoint: [],
        supplierCarriers: [],
        dealers: [],
        clients:[],
    };

    const COLUMN_DEFINITION = (self) => [
        {
            label: self.$t('column.loadNumber'),
            key: 'load_number',
            sortable: true,
        },
        {
            label: self.$t('column.client'),
            key: 'client_id',
            sortable: true,
        },
        {
            label: self.$t('column.supplierCarrier'),
            key: 'supplier_carrier_id',
            sortable: true,
        },
        {
            label: self.$t('column.vinNumber'),
            key: 'vin_number',
            sortable: false,
        },
        {
            label: self.$t('column.fromDealer'),
            key: 'from_to_dealer_id',
            sortable: false,
        },
        {
            label: self.$t('column.loadingPoint'),
            key: 'from_location_id',
            sortable: false,
        },
        {
            label: self.$t('column.toDealer'),
            key: 'to_dealer_id',
            sortable: true,
        },
        {
            label: self.$t('column.unLoadingPoint'),
            key: 'to_location_id',
            sortable: false,
        },
        {
            label: self.$t('column.driver'),
            key: 'driver_id',
            sortable: true,
        },
        {
            label: self.$t('column.transportVehicle'),
            key: 'transport_vehicle_id',
            sortable: true,
        },
        {
            label: self.$t('column.qty'),
            key: 'qty',
            sortable: true,
        },
        {
            label: self.$t('column.loadingDate'),
            key: 'loading_date',
            sortable: false,
        },
        {
            label: self.$t('column.status'),
            key: 'status',
            sortable: true,
        },
        (self.$global.hasAnyPermission(['ddloadsupdate', 'ddloadsview'])
            ? {
                label: self.$t('column.action'),
                class: 'text-right w-100px',
                key: 'action',
            } : {}),
    ];

    export default {
        mixins: [ListingMixin, ExcelExportMixin],
        components: {
            Treeselect,
            Detail,
            JsonExcel
        },
        data() {
            return {
                operationTitle: 'title.orders',
                formFields: {...FORM_STATE},
                filters: {...FILTER_STATE},
                listUrl: 'dealer/to/dealer/loads',
                columns: COLUMN_DEFINITION(this),
                dropdowns: {
                    supplierCarriers: [],
                    locations: [],
                    dealers: [],
                    orders: [],
                    countries: [],
                    currencies: [],
                    brands: [],
                    models: [],
                    configCode: [],
                    drivers: [],
                    vehicles: [],
                    status: [
                        {id: 1, label: this.$t('title.transportOrder')},
                        {id: 2, label: this.$t('title.announced')},
                        {id: 3, label: this.$t('title.rejected')},
                        {id: 4, label: this.$t('title.confirmed')},
                        {id: 5, label: this.$t('title.loaded')},
                        {id: 6, label: this.$t('title.stockExitInTransit')},
                        {id: 7, label: this.$t('title.deliveryRequested')},
                        {id: 8, label: this.$t('title.delivered')},
                    ],
                    loadingPoint: [],
                    unloadingPoint: [],
                    clients: [],
                },
                show: true,
                editLoad: null,
                selectedOrderId: null,
            }
        },
        mounted() {
            this.getBrands();
            this.getModels();
            this.getDrivers();
            this.getTransportVehicles();
            this.getLocations()
            this.getSupplierCarriers()
            this.getDealers()
            this.getClients()

            if (this.$route.query && this.$route.query.operation === 'edit' && this.$route.query.oToken) {
                this.handleEditClick(this.$route.query.oToken)
            }

            this.$title = this.$t('title.dealerToDealerLoads')
        },
        methods: {
            toggleDetails(row) {
                this.$set(row, '_showDetails', ((row._showDetails) ? !row._showDetails : true))
            },
            setOperation(operation = 'add', operationToken = null) {
                this.operationTitle = (operation === 'add' ? 'title.addOrder' : 'title.editOrder')
                this.$router.replace({
                    query: Object.assign({},
                        this.$route.query,
                        {
                            ...this.listQueryParams,
                            operation: operation,
                            oToken: operationToken,
                        },
                    ),
                }).then(() => {
                }).catch(() => {
                })
            },
            async handleSubmit() {
                this.formErrors = new Error({})
                this.formFields.price_id = null;
                this.formFields.route_id = null;
                this.formFields.price_period_id = null;

                if (this.editLoad.dealer_to_dealer_load_orders.length === this.formFields.deleted_orders.length) {
                    const errors = {orders: [this.$t('validation.minimumOrderRequired')]}
                    this.formErrors = new Error(errors)
                    return false;
                }

                if (this.formFields.supplier_carrier_id) {
                    const supplier = _.find(this.dropdowns.supplierCarriers, {id: this.formFields.supplier_carrier_id})

                    if (supplier.prices.length > 0) {
                        this.formFields.price_id = supplier.prices[0].id;
                        this.formFields.route_id = supplier.prices[0].route.id;
                        this.formFields.price_period_id = supplier.prices[0].price_periods[0].id;
                    }
                }

                try {
                    const response = await request({
                        url: 'dealer/to/dealer/loads/update',
                        method: 'post',
                        data: {
                            id: this.formFields.id,
                            supplier_carrier_id: this.formFields.supplier_carrier_id,
                            price_id: this.formFields.price_id,
                            route_id: this.formFields.route_id,
                            price_period_id: this.formFields.price_period_id,
                            to_location_id: this.formFields.to_location_id,
                            to_dealer_id: this.formFields.to_dealer_id,
                            comments: this.formFields.comments,
                            _method: 'post',
                            deleted_orders: this.formFields.deleted_orders,
                            new_orders: this.formFields.new_orders.map((item) => ({id: item.id})),
                            status: this.formFields.status,
                            skip_dealer_confirmation: this.formFields.skip_dealer_confirmation,
                            announce: this.formFields.announce
                        },
                    })

                    if (this.formFields.id) {
                        this.itemUpdated()
                    }

                    this.handleOperationClose()
                } catch (error) {
                    if (error.request && error.request.status && error.request.status === 422) {
                        this.formErrors = new Error(JSON.parse(error.request.responseText).errors)
                        return false
                    }

                    this.handleServerError(error)
                }
            },
            async handleEditClick(id) {
                this.dropdowns.orders = []
                this.formFields.new_orders = []
                this.formFields.deleted_orders = []
                this.operationTitle = this.$t('title.editLoad')
                request({url: `/dealer/to/dealer/loads/detail/${id}`})
                    .then((response) => {
                        const {data} = response
                        this.editLoad = data
                        this.formFields.id = data.id
                        this.formFields.supplier_carrier_id = (data.supplier_carrier ? data.supplier_carrier.id : null)
                        this.formFields.to_location_id = data.dealer_to_dealer_load_orders[0].to_location.id
                        this.formFields.to_dealer_id = data.to_dealer.id
                        this.formFields.skip_dealer_confirmation = data.skip_dealer_confirmation
                        this.formFields.limit = data.qty
                        this.formFields.status = data.status
                        this.getOrders(data)
                        this.getDealerToDealerOrderNearLocationSupplierCarrier(data)
                    })
                    .catch((error) => {
                        this.handleServerError(error)
                    })
            },
            async handleDeleteClick(id) {
                try {
                    const response = await request({
                        method: 'post',
                        url: '/dealer/to/dealer/loads/delete',
                        data: {
                            id: id,
                        },
                    })

                    this.loadList(this.listQueryParams)
                    this.itemDeleted()
                } catch (error) {
                    if (error.request && error.request.status && error.request.status === 422) {
                        this.itemDeleteFailsBecsDependency()
                        return false;
                    }

                    this.itemDeleteFails()
                }
            },
            async getOrders(item) {
                try {
                    const params = {
                        ids: item.dealer_to_dealer_load_orders.map(i => i.order.id),
                        dealer_location: item.dealer_to_dealer_load_orders[0].to_location.id,
                        client: item.client.id,
                        brand: item.dealer_to_dealer_load_orders[0].order.brand.id,
                        model: item.dealer_to_dealer_load_orders[0].order.model.id,
                        status: [17],
                    }

                    const {data} = await request({
                        method: "post",
                        url: 'dropdowns/orders/dealer/to/dealer/update',
                        params: params,
                        paramsSerializer: ((params) => qs.stringify(params)),
                    })

                    this.dropdowns.orders = data.map(item => ({
                        id: item.id,
                        label: `${item.order_id} | ${item.vin_number}`,
                        item: item
                    }))
                } catch (e) {

                }
            },
            async getLocations() {
                try {
                    const response = await request({
                        url: '/dropdowns/locations',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.locations = data
                    this.dropdowns.loadingPoint = data
                    this.dropdowns.unloadingPoint = data

                } catch (e) {
                    this.dropdowns.locations = []
                    this.dropdowns.loadingPoint = []
                    this.dropdowns.unloadingPoint = []

                }
            },
            async getDealers() {
                try {
                    const response = await request({
                        url: '/dropdowns/dealers',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.dealers = data

                } catch (e) {
                    this.dropdowns.dealers = []
                }
            },
            async getSupplierCarriers() {
                try {
                    const response = await request({
                        url: '/dropdowns/suppliers/carrier',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.supplierCarriers = data

                } catch (e) {
                    this.dropdowns.supplierCarriers = []
                }
            },
            async getBrands() {
                try {
                    const response = await request({
                        url: '/dropdowns/brands',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.brands = data

                } catch (e) {
                    this.dropdowns.brands = []
                }
            },
            async getModels() {
                try {
                    const response = await request({
                        url: '/dropdowns/models',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.models = data.map(item => ({id: item.id, label: `${item.label}`}))
                    this.dropdowns.configCode = data.map(item => ({
                        id: item.version_code,
                        label: item.version_code,
                        model_id: item.id
                    }))
                } catch (e) {
                    this.dropdowns.models = []
                    this.dropdowns.configCode = []
                }
            },
            async getDrivers() {
                try {
                    const response = await request({
                        url: '/dropdowns/drivers',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.drivers = data
                } catch (e) {
                    this.dropdowns.drivers = []
                }
            },
            async getTransportVehicles() {
                try {
                    const response = await request({
                        url: '/dropdowns/transport/vehicles',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.vehicles = data
                } catch (e) {
                    this.dropdowns.vehicles = []
                }
            },
            async getDealerToDealerOrderNearLocationSupplierCarrier(orders) {
                this.dropdowns.supplierCarriers = [];

                let from_location = null;
                let to_location = null;
                const brands = [];
                const models = [];
                const ids = [];
                _.map(orders.dealer_to_dealer_load_orders, (val) => {
                    from_location = val.from_location
                    to_location = val.to_location
                    brands.push(val.order.brand.id)
                    models.push(val.order.model.id)
                    ids.push(val.order.id)
                })

                try {
                    const response = await request({
                        url: '/dropdowns/orders/matched/location/dd/carrier/suppliers',
                        method: "post",
                        data: {
                            orders: [{
                                id: 1,
                                from_location: from_location,
                                brands: _.uniq(brands),
                                models: _.uniq(models),
                                to_location: to_location,
                                ids: ids
                            }],
                            created_at: orders.created_at
                        }
                    })

                    const {data} = response
                    _.map(data, (group, index) => {
                        this.dropdowns.supplierCarriers = group.suppliers
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            async getClients() {
                try {
                    const response = await request({
                        url: '/dropdowns/clients',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.clients = data

                } catch (e) {
                    this.dropdowns.clients = []
                }
            },
            handleSelectModelsSelect(changeValue) {
                this.filters.configCode = []
            },
            validateOrderError() {
                const errors = {}
                let hasError = false
                if (!this.selectedOrderId) {
                    errors.order_id = [this.$t('validation.required')]
                    hasError = true
                }

                if (_.find(this.editLoad.dealer_to_dealer_load_orders, {id: this.selectedOrderId})) {
                    errors.order_id = [this.$t('validation.duplicate')]
                    hasError = true
                }

                this.formErrors = new Error(errors)
                return hasError
            },
            handleAddOrderClick() {
                if (this.validateOrderError())
                    return false

                this.formFields.new_orders.push(_.find(this.dropdowns.orders, {id: this.selectedOrderId}).item)
                this.selectedOrderId = null
            },
            handleDeleteNewOrderClick(orderId) {
                const orders = this.formFields.new_orders
                orders.splice(orderId, 1)
                this.formFields.new_orders = orders
            },
            handleDeleteOrderClick(orderId) {
                this.formFields.deleted_orders.push(orderId)
            },
            handleUndoDeleteClick(orderId) {
                const orders = this.formFields.deleted_orders
                orders.splice(orderId, 1)
                this.formFields.deleted_orders = _.compact(orders)
            },
            hasListAccess() {
                return this.$global.hasPermission('ddloadsview')
            },
            getExtraParams() {
                return {
                    filters: {
                        ...this.filters,
                        from_date: ((this.filters.from_date) ? this.$global.dateToUtcDate(this.filters.from_date, 'YYYY-MM-DD', 'YYYY-MM-DD') : ''),
                        to_date: ((this.filters.to_date) ? this.$global.dateToUtcDate(this.filters.to_date, 'YYYY-MM-DD', 'YYYY-MM-DD') : ''),
                    },
                }
            },
            handleResetFilterClick() {
                this.filters = {...FILTER_STATE}
                this.isFilterApplied = 'reset'
                this.handleResetClick()
                this.loadList(this.listQueryParams)
            },
            afterCloseOperation() {
                this.formFields = {...FORM_STATE}
                this.editLoad = null
                this.selectedOrderId = null
                this.dropdowns.orders = []
                this.formFields.deleted_orders = []
                this.formFields.new_orders = []
            },
        },
        computed: {
            ...mapState([
                'global',
                'settings'
            ]),
        },
    }
</script>
<style lang="scss">
    .w-80 {
        width: 80px;
    }

    .w-220 {
        width: 220px;
    }

    .in-center {
        position: relative;
        top: 1px;
        margin-right: 8px;
    }

    .order-select-chbx {
        position: absolute;
        right: -7px;
        top: -7px;
    }

    .add-load-btn {
        position: absolute;
        top: 12px;
        right: 50px;
    }

    @media screen and (max-width: 768px) {
        .ant-drawer-content-wrapper {
            width: 98% !important;
        }
    }

    .min-height-375 {
        min-height: 375px;
    }

    .w-100px {
        width: 100px;
    }
</style>
